<template>
  <div class="col-lg-9">

    <!--begin::Signin-->
    <div class="login-form login-signin">
      <div class="text-center mb-5 mb-lg-5">
        <!--        <h3 class="font-size-h1">Sign In</h3>-->
        <img :src="getLogo()" alt="">
        <!--        <p class="text-muted font-weight-semi-bold">-->
        <!--          Enter your email and password-->
        <!--        </p>-->
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div
            role="alert"
            v-bind:class="{ show: errors.length }"
            class="alert fade alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error.message }}
          </div>
        </div>

        <b-form-group
            id="example-input-group-1"
            label=""
            label-for="example-input-1"
        >
          <b-form-input
              class="form-control form-control-solid h-auto py-5 px-6"
              id="example-input-1"
              name="example-input-1"
              placeholder="Email"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Email is required and a valid email address.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
            id="example-input-group-2"
            label=""
            label-for="example-input-2"
        >
          <b-form-input
              class="form-control form-control-solid h-auto py-5 px-6"
              type="password"
              id="example-input-2"
              name="example-input-2"
              placeholder="Password"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Password is required.
          </b-form-invalid-feedback>
        </b-form-group>

<!--        &lt;!&ndash;begin::Action&ndash;&gt;-->
<!--        <div-->
<!--            class="form-group d-flex flex-wrap align-items-center"-->
<!--        >-->
<!--            <span class="font-weight-bold font-size-3 text-dark-60">-->
<!--            Don't have an account yet?-->
<!--              </span>-->
<!--            <router-link-->
<!--                class="font-weight-bold font-size-3 ml-2"-->
<!--                :to="{ name: 'register' }"-->
<!--            >-->
<!--              Sign Up!-->
<!--            </router-link>-->
<!--        </div>-->
<!--        &lt;!&ndash;end::Action&ndash;&gt;-->

        <!--begin::Action-->
        <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
        >
          <span class="font-weight-bold font-size-3 text-dark-60">
            <router-link
                class="font-weight-bold font-size-3"
                :to="{ name: 'forgot-password' }"
            >
<!--            Forgot Password?-->
          </router-link>
              </span>
          <button
              ref="kt_login_signin_submit"
              class="btn btn-theme font-weight-bold px-9 py-4 my-3 font-size-3"
          >
            Sign In
          </button>
        </div>

<!--        <div-->
<!--            class="form-group text-center"-->
<!--        >-->
<!--          <span class="font-weight-bold font-size-3 text-dark-60">-->
<!--            Don't have an account yet?-->
<!--            <router-link-->
<!--                class="font-weight-bold font-size-3"-->
<!--                :to="{ name: 'register' }"-->
<!--            >-->
<!--            Sign Up!-->
<!--          </router-link>-->
<!--              </span>-->
<!--        </div>-->
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import {mapState} from "vuex";
import {LOGIN, CLEAR_AUTH_ERRORS} from "@/core/services/store/auth.module";

import {validationMixin} from "vuelidate";
import {email, minLength, required} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
        password: ""
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(CLEAR_AUTH_ERRORS);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      submitButton.disabled = true;

      // send login request
      this.$store
          .dispatch(LOGIN, {email, password})
          // go to which page after successfully login
          .then((data) => {
            if (data._metadata.outcomeCode === 0) {
              submitButton.classList.remove(
                  "spinner",
                  "spinner-light",
                  "spinner-right"
              );
              this.$router.push("dashboard");
              submitButton.disabled = false;
            } else {
              submitButton.classList.remove(
                  "spinner",
                  "spinner-light",
                  "spinner-right"
              );
              submitButton.disabled = false;
            }
          });
    },
    getLogo() {
      return process.env.BASE_URL + "media/logos/logo.png";
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
